'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ScopesList from './ScopesList';

const ScopesCollection = ({
  scopesCollection
}) => {
  if (!scopesCollection || !scopesCollection.length) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "developer-docs-shared-components.requirements.scopes.noScopes"
    });
  }

  return /*#__PURE__*/_jsx("div", {
    className: "flex-wrap align-center",
    children: scopesCollection.map((scopes, index) => /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(ScopesList, {
        scopes: scopes
      }), index < scopesCollection.length - 1 && /*#__PURE__*/_jsx(FormattedMessage, {
        className: "m-right-2",
        message: "developer-docs-shared-components.requirements.scopes.orSeparator"
      })]
    }, `${scopes[0]}-${index}`))
  });
};

ScopesCollection.propTypes = {
  // Each nestedArray scopesCollection represents an "or" scope relationship.
  scopesCollection: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};
export default ScopesCollection;